import * as actionTypes from './actionTypes';

export const setHotelDestinationCity = (city, cityCode, countryCode) => {
    return {
        type: actionTypes.SET_HOTEL_DESTINATION_CITY,
        city: city,
        cityCode: cityCode,
        countryCode: countryCode
    }
}

export const searchHotelDestinationCity = (city) => {
    return {
        type: actionTypes.SEARCH_HOTEL_DESTINATION_CITY,
        city: city
    }
}

export const setHotelDestinationValidation = () => {
    return {
        type: actionTypes.SET_HOTEL_DESTINATION_VALIDATION
    }
}

export const setHotelCheckinDate = (checkinDate) => {
    return {
        type: actionTypes.SET_HOTEL_CHECKIN_DATE,
        checkinDate: checkinDate
    }
}

export const setHotelCheckoutDate = (checkinDate, checkoutDate) => {
    return {
        type: actionTypes.SET_HOTEL_CHECKOUT_DATE,
        checkinDate: checkinDate,
        checkoutDate: checkoutDate
    }
}

export const clearHotelEndDate = () => {
    return {
        type: actionTypes.CLEAR_HOTEL_END_DATE
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/bookingEngineHotel.js